import { computed, Directive, effect, inject, input, TemplateRef, untracked, ViewContainerRef } from '@angular/core';

import { AuthService } from '../auth/services/auth.service';

@Directive({
  selector: '[crmTgbotHasGroup]',
})
export class HasGroupDirective {
  private readonly authService = inject(AuthService);
  private readonly templateRef = inject(TemplateRef);
  private readonly viewContainerRef = inject(ViewContainerRef);
  /**
   * Input for groups array. If this will be empty array then element will be displayed
   */
  readonly crmTgbotHasGroup = input.required<string[]>();

  private readonly canShow = computed(() => {
    const user = this.authService.user();
    const required = this.crmTgbotHasGroup();
    if (!user) return false;
    if (!required.length) return true;

    return required.some((g) => user.groups?.includes(g));
  });

  constructor() {
    let viewCreated = false;

    effect(() => {
      const visible = this.canShow();

      if (visible && !viewCreated) {
        untracked(() => {
          this.viewContainerRef.createEmbeddedView(this.templateRef);
        });
        viewCreated = true;
      } else if (!visible && viewCreated) {
        untracked(() => this.viewContainerRef.clear());
        viewCreated = false;
      }
    });
  }
}
